import React, { createContext, memo, useEffect, useMemo } from 'react'
import { fetchStoreOrderAction, selectOrder } from 'src/redux/order'
import useAppDispatch from 'src/hooks/useAppDispatcher'
import useAppSelector from 'src/hooks/useAppSelector'
import { newrelicTrackOrderStoreId } from 'src/utils/newrelicLogger'

const StoreOrderContext = createContext({
  storeOrder: {
    data: {} as Oms.V4.StoreOrder
  }
})

export const StoreOrderProvider = memo(
  ({ children }: { children }): JSX.Element => {
    const dispatch = useAppDispatch()
    const storeOrder = useAppSelector(selectOrder).storeOrder
    const storeOrderContext = useMemo(
      () => ({
        storeOrder,
        fetchStoreOrderAction: () => dispatch(fetchStoreOrderAction())
      }),
      [dispatch, storeOrder]
    )

    useEffect(() => {
      newrelicTrackOrderStoreId(storeOrder?.data?.id)
    }, [storeOrder])

    return (
      <StoreOrderContext.Provider value={storeOrderContext}>
        {children}
      </StoreOrderContext.Provider>
    )
  }
)

export default StoreOrderContext
